module.exports = __webpack_public_path__ + "static/media/UNIAO_EUROPEIA.0e10975e.svg";